import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Checkbox, List, Row, Col } from 'antd';
import CustomButton from '../../../../../v2-components/Antd/Button';

const ShareOrderModal = ({ open, onCancel, onSend, products, isLoading }) => {
  const [form] = Form.useForm();
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  console.log('selectedProductsIds',selectedProductIds)

  useEffect(() => {
    if (open && products) {
      setSelectedProductIds(products.map(p => p.id));
      form.resetFields();
    }
  }, [open, products, form]);

  const handleCheckboxChange = (checkedValues) => {
    setSelectedProductIds(checkedValues);
  };

  const handleFinish = (values) => {
    if (selectedProductIds.length === 0) {
      return; 
    }
    
    onSend(values.email, selectedProductIds);
  };

  return (
    <Modal
      title="Compartir"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <p style={{ marginBottom: 16 }}>Seleccione los productos:</p>
        
        <Form.Item name="products" valuePropName="checked">
          <Checkbox.Group 
            style={{ width: '100%' }} 
            value={selectedProductIds}
            onChange={handleCheckboxChange}
          >
            <List
              dataSource={products}
              renderItem={(item) => (
                <List.Item>
                  <Checkbox value={item.id} style={{ width: '100%' }}>
                    {item?.name}
                  </Checkbox>
                </List.Item>
              )}
              style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: 24 }}
            />
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          label="Correo electrónico"
          name="email"
          rules={[
            { required: true, message: 'Por favor ingrese un correo electrónico' },
            { type: 'email', message: 'Ingrese un correo válido' }
          ]}
        >
          <Input placeholder="ejemplo@correo.com" />
        </Form.Item>

        <Row justify="end" gutter={16} style={{ marginTop: 24 }}>
          <Col>
            <CustomButton onClick={onCancel} disabled={isLoading}>
              Cancelar
            </CustomButton>
          </Col>
          <Col>
            <CustomButton 
              type="primary" 
              htmlType="submit" 
              loading={isLoading}
              disabled={selectedProductIds.length === 0}
            >
              Enviar
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ShareOrderModal;